/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const CartIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M3.6 1.2A2.4 2.4 0 016 3.6a1.2 1.2 0 001.2 1.2h12.609c.322-.001.713-.003 1.055.099a2.4 2.4 0 011.702 2.008c.043.354-.023.74-.077 1.057l-.015.094-.026.153c-.184 1.107-.31 1.865-.583 2.515a6 6 0 01-4.147 3.512c-.685.163-1.454.162-2.576.162H12a2.4 2.4 0 00-2.216 1.476A3.601 3.601 0 018.4 22.8a3.6 3.6 0 01-1.202-6.994 10.8 10.8 0 00-1.138-4.603L4.8 8.683A11.367 11.367 0 013.6 3.6c-1.988 0-2.4-.537-2.4-1.2 0-.663.412-1.2 2.4-1.2zM18 15.6a3.6 3.6 0 110 7.2 3.6 3.6 0 010-7.2zM8.4 18a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zm9.6 0a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zM6.742 7.171c.064.148.132.294.205.439l1.26 2.52a13.2 13.2 0 011.013 2.757A4.778 4.778 0 0112 12h2.987c1.337 0 1.801-.008 2.178-.097a3.6 3.6 0 002.487-2.108c.15-.356.234-.813.454-2.132.037-.223.058-.348.069-.44l.002-.017-.017-.001a5.291 5.291 0 00-.218-.005H7.2c-.155 0-.308-.01-.458-.029z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
CartIconSvg.displayName = 'CartIconSvg'

const CartIcon = forwardRef((props, ref) => <Icon component={CartIconSvg} ref={ref} {...props} />)
CartIcon.displayName = 'CartIcon'

CartIcon.defaultProps = {
	...Icon.defaultProps,
}
CartIcon.propTypes = {
	...Icon.propTypes,
}

export default CartIcon
export { CartIconSvg }
